/**
 *
 * Copyright 2020-2026 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

export const LOAF_MODULE_NAME = 'splunk-loaf'
export const LOAF_SOURCE_WINDOW_MS = 60_000
export const LONG_ANIMATION_FRAME_PERFORMANCE_TYPE = 'long-animation-frame'
export const MAX_LOAF_SCRIPT_SUMMARIES = 3
export const MAX_LOAF_SPANS_PER_SOURCE_WINDOW = 50
